import { Config, CanvasInfo, SystemEnv } from "./index";
import * as THREE from "three";

/* Sun
 * 太陽クラス.
 */

export class Sun {
    _instance: THREE.DirectionalLight;
    public get me(): THREE.DirectionalLight { return this._instance; }
    public set me(i: THREE.DirectionalLight) { this._instance = i; }

    constructor(color: number, intensity: number, doShadow?: boolean) {
        this.me = new THREE.DirectionalLight(color, intensity);
        this.me.name = "特定の方向に放射される光";
    }
    public get position(): THREE.Vector3 { return this.me.position; }
    public set position(pos: THREE.Vector3) { this.me.position.set(pos.x, pos.y, pos.z); }
    public reset() {
        this.me = undefined;
    }
}

/* Ambient
 * 環境光クラス.
 */
export class AmbientLight {
    _instance: THREE.AmbientLight;
    public get me(): THREE.AmbientLight { return this._instance; }
    public set me(i: THREE.AmbientLight) { this._instance = i; }

    constructor(color: number) {
        this.me = new THREE.AmbientLight(color, 0);
        // this.me = new THREE.AmbientLight(color);
        this.me.name = "環境光";
    }
    public reset() {
        this.me = undefined;
    }
}
